<div class="signature-rich-editor flex-column fxFlex-100p">
  <!-- FRENCH -->
  <div class="signature-lang-label">Français</div>

  <p-editor
    #signatureFrEditor
    *ngIf="editMode"
    [ngModel]="signatureFr"
    (ngModelChange)="onSignatureFrChange($event)"
    (onInit)="onEditorInitFR($event)"
    [style]="{
      height: '160px',
      width: '100%',
      'background-color': '#ffffff',
    }"
  >
    <ng-template pTemplate="header">
      <span class="ql-formats">
        <select class="ql-font"></select>
        <select class="ql-size"></select>
      </span>
      <span class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
        <button class="ql-strike"></button>
      </span>
      <span class="ql-formats">
        <select class="ql-color"></select>
        <select class="ql-background"></select>
      </span>
      <span class="ql-formats">
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
        <button class="ql-indent" value="-1"></button>
        <button class="ql-indent" value="+1"></button>
      </span>
      <span class="ql-formats">
        <button class="ql-link"></button>
      </span>
      <span class="ql-formats">
        <select class="ql-tags"></select>
      </span>
      <span class="ql-formats">
        <app-emoji-picker-button
          [editor]="signatureFrEditor"
        ></app-emoji-picker-button>
      </span>
    </ng-template>
  </p-editor>

  <div
    *ngIf="!editMode && signatureFr"
    class="signature-preview"
    [innerHTML]="signatureFr"
  ></div>
  <div
    *ngIf="!editMode && !signatureFr"
    class="signature-empty"
  ></div>

  <!-- ENGLISH -->
  <div class="signature-lang-label mt-16">English</div>

  <p-editor
    #signatureEnEditor
    *ngIf="editMode"
    [ngModel]="signatureEn"
    (ngModelChange)="onSignatureEnChange($event)"
    (onInit)="onEditorInitEN($event)"
    [style]="{
      height: '160px',
      width: '100%',
      'background-color': '#ffffff',
    }"
  >
    <ng-template pTemplate="header">
      <span class="ql-formats">
        <select class="ql-font"></select>
        <select class="ql-size"></select>
      </span>
      <span class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
        <button class="ql-strike"></button>
      </span>
      <span class="ql-formats">
        <select class="ql-color"></select>
        <select class="ql-background"></select>
      </span>
      <span class="ql-formats">
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
        <button class="ql-indent" value="-1"></button>
        <button class="ql-indent" value="+1"></button>
      </span>
      <span class="ql-formats">
        <button class="ql-link"></button>
      </span>
      <span class="ql-formats">
        <select class="ql-tags"></select>
      </span>
      <span class="ql-formats">
        <app-emoji-picker-button
          [editor]="signatureEnEditor"
        ></app-emoji-picker-button>
      </span>
    </ng-template>
  </p-editor>

  <div
    *ngIf="!editMode && signatureEn"
    class="signature-preview"
    [innerHTML]="signatureEn"
  ></div>
  <div
    *ngIf="!editMode && !signatureEn"
    class="signature-empty"
  ></div>
</div>
